// LOADER CONSTANTS
import { IconGreenCheck } from "../components/common/Icons/GreenCheck";

export const loaderConstants = {
    CALCULATE:{
        text:'Done',
        loader:false,
        icon:<IconGreenCheck className="icon-check" height="16" width="16"/>
    },
    CALCULATING: {
        text: 'Calculating',
        loader:true,
        icon:''
    },
    REMOVE_CALCULATE: {
        text: '',
        loader:false,
        icon:''
    }
};

export const disclaimer =
    'The above results are based on the limited information you have provided. This calculator is a guide only, please seek financial advice before making any decision.';

export const storage = {
    INITIAL_VALUE: 'initial_value',
    POSTCODE_REDUX_STATE: 'postcode_redux_state'
}

export const PLUGIN_NAME = "Postcode Calculator";

export const RESULT_EMAIL_SENT_NOTICE =  "The result has been successfully sent to your email. Please make sure to check your spam or junk folders.";

export const EQUIRY_SENT_NOTICE =  "Thank you for your enquiry. We will give you a call within 24 hours, please check your email for the enquiry details.";
export const GTM_CONSTANTS ={
    LABEL: "Postcode Calculator",
    ENQUIRY_ACTION: "Full application completed",
    CALCULATION_ACTION: "Calculation button clicked",
    CATEGORY: "Customer Assessment Tool"
  }
